import {useGraphql} from "@/core/graphql/service"

import {genqlBuilder} from "@/core/graphql/genql/builder"

import {QueryGenqlSelection, Query} from "../schema"

export type QueryPushVapidPublicKeyVars = {}

export type PushVapidPublicKeyResult = Query['push_vapid_public_key']

export function pushVapidPublicKeyQuery(query: QueryGenqlSelection['push_vapid_public_key'] | null) {
      
    const build = (variables: QueryPushVapidPublicKeyVars) => genqlBuilder.build(query ? {push_vapid_public_key: query} : {__scalar: true}, {push_vapid_public_key: variables})
    const run = (variables: QueryPushVapidPublicKeyVars | null = null): Promise<PushVapidPublicKeyResult | null> => {
        const {queryWrapped} = useGraphql()
        return queryWrapped(build(variables || {}))
    }
                
    return {
      build,  
      run,
      _variables: {} as QueryPushVapidPublicKeyVars,
      _result: {} as PushVapidPublicKeyResult,
    }
}

export default pushVapidPublicKeyQuery